import {
	AppIdentConfig,
} from '@config/appIdentConfigs';

export const getOrganization = (meInfo: any, appConfig: AppIdentConfig) => {
	if (!meInfo) return undefined;

	// Use app-specific organization extraction
	return appConfig.extractOrganization!(meInfo);
};

export const getGroups = (meInfo: any, appConfig: AppIdentConfig): Record<string, string[]> => {
	if (!meInfo || !appConfig.extractGroups) return {};
	return appConfig.extractGroups(meInfo);
};
